import React from 'react'
import { ElfsightWidget } from 'react-elfsight-widget'

export default function ElfsightReviewsWidget({ providerId }) {
  return (
    <ElfsightWidget
      widgetId={providerId}
      lazy
      modern
    />
  )
}
